import { render } from "./VuexBuildingFormItem.vue?vue&type=template&id=f300d7fc&scoped=true"
import script from "./VuexBuildingFormItem.vue?vue&type=script&lang=js"
export * from "./VuexBuildingFormItem.vue?vue&type=script&lang=js"

import "./VuexBuildingFormItem.vue?vue&type=style&index=0&id=f300d7fc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3809301774/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f300d7fc"]])

export default __exports__